import React from 'react';
import { NewsletterForm } from '../forms/NewsletterForm';
export function NewsletterSection() {
  return <section className="bg-midnight py-20 text-white" data-id="element-258" data-mp="1yl2v8b8wdjlc">
      <div className="container-page grid gap-10 lg:grid-cols-12 lg:items-center" data-id="element-259" data-mp="1ymnuge65pqpj">
        <div className="lg:col-span-5" data-id="element-260" data-mp="2chzmuewub53a">
          <h2 className="font-display text-4xl font-semibold leading-tight" data-id="element-261" data-mp="27kgbbmrj16f1">Leadership insight, occasionally.</h2>
          <p className="mt-4 leading-relaxed text-white/70" data-id="element-262" data-mp="2ljz8jkisuxck">
            Considered perspectives on executive leadership, board governance and the talent market. No more than once a month.
          </p>
        </div>
        <div className="lg:col-span-6 lg:col-start-7" data-id="element-263" data-mp="2v98zgx1wq9z3">
          <NewsletterForm tone="dark" data-id="element-264" data-mp="2qbqz3v1yh32p" />
        </div>
      </div>
    </section>;
}